var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},_vm._l((_vm.elements),function(item,i){return _c('block',_vm._g(_vm._b({key:i},'block',_vm.$options.filters.normalize(item),false),_vm.$listeners))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }